import { useGetMyCert } from "../../../Api/ApiCerts/axiosGetCerts";

import closeIcon from "../../../img/closeIcon.svg";
import "./SignatureModal.css";

/**
 * Modal that handles signing documents
 * @param {{
 *  onCloseModal : () => void
 *  isModalMessage : string,
 *  onSend : (body : *) => void,
 *  description : string,
 *  children : import("react").ReactNode | undefined
 * }} props
 * @returns {import("react").ReactNode}
 */

export function SignatureModal({
  onSend,
  onCloseModal,
  isModalMessage,
  description,
  children,
}) {

  const { isLoading: isCertLoading, ...myCert } = useGetMyCert();

  return (
    <div className="signature-modal__container">
      <div className="signature-modal">
        <div className="signature-modal__title">
          <h3>{description}</h3>
          <img onClick={onCloseModal} src={closeIcon} alt={"иконка крестик"} />
        </div>
        {children}
        <div className="signature-modal-cert-block">
          {(function displayMessage() {
            if (isCertLoading) return "Loading";
            if (!myCert.subject)
              return (
                <p className="signature-modal-cert-block-no-sign-text">{`Please install certificate with SubjectKeyId = ${myCert.subjKeyId}`}</p>
              );
            return (
              <div className="signature-modal-cert-block__cert">
                Sign with :
                <br />
                <span>{myCert.subject}</span> ?
              </div>
            );
          })()}

          <p className="modal-input-block-error-text">{isModalMessage}</p>
        </div>
        <div className="signature-modal__buttons-block">
          <button
            onClick={() => onCloseModal()}
            className="signature-modal__button-cancel"
            type={"button"}
          >
            Cancel
          </button>
          <button
            disabled={!myCert.subject}
            onClick={() => onSend(myCert.subjKeyId)}
            className="signature-modal__button-create"
            type={"button"}
          >
            Send
          </button>
        </div>
      </div>
    </div>
  );
}
